export * from './ProductsIndexTableBody.types';
export { default as ProductsIndexTableBody } from './ProductsIndexTableBody';
